import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CatalogComponent } from '../../dashboard/oem/catalog/catalog.component';
import { CatalogService } from 'src/app/services/shared/catalog.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { combineLatest } from 'rxjs';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-brand-profile',
  templateUrl: './brand-profile.component.html',
  styleUrls: ['./brand-profile.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':increment', [
        style({ transform: 'translateX(100%)' }),
        animate('0.3s ease-in-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':decrement', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.3s ease-in-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.3s ease-in-out', style({ transform: 'translateX(0)' })),
      ]),
    ]),
  ],
})
export class BrandProfileComponent implements OnInit {
  @ViewChild(CompanyProfileComponent) companyProfileComponent!: CompanyProfileComponent;
  tabSliderPosition = 0; // Initial position of the tab slider
  tabSliderWidth = 0; // Initial width of the tab slider
  activeTab = -1;
  previousTab: number = 0;
  animateContent: boolean = false;
  selectedTabName : string = 'Company Profile';
  id: string | null = null;
  type : string | null = null;
  isDistributorProfile : boolean = false;
  profileData: any;
  brandData: any;
  captureMode: boolean = false;
  products: any[] = [];
  distributorNetwork: any[] = [];
  brands: any[] = [];
  cdr: any;
  brandProfileProducts: any='';
  isLogin: any;

  constructor(
    private spinnerService: SpinnerService,
    private oemService : OemService,
    private distributorService: DistributorService,
    private route: ActivatedRoute,
    private router: Router,
    private allProductService: AllProductService,
  ) { }

  ngOnInit(): void {
    this.isLogin = localStorage.getItem('accountName');
    this.spinnerService.showSpinner();
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .subscribe(([paramMap, queryParamMap]) => {
        this.id = paramMap.get('id');
        this.type = queryParamMap.get('type');
        if (this.id && this.type) {
          this.fetchProfileData(this.id, this.type);
        }
      });
  }

  fetchProfileData(id: string, type: string): void {
    if (type === 'distributor') {
    //  Call distributor API
    this.getDistributorById(id);
    this.getAllProductsById(id);
    this.getBrandsByDistributorId(id);
    } else if(type === 'brand') {
      // Call brand API
      this.getOEMsBYId(id);
      this.getAllProductsById(id);
      this.getAllDistributorById(id);
    }
  }

  desc: string = '';
  getOEMsBYId(id: string): void {
    this.oemService.getOEMById(id).subscribe({
      next: (response) => {
        this.profileData = {
          ...response.data,
          type: 'brand'
        };
        this.activeTab = 0;
        this.spinnerService.hideSpinner();
        this.desc = response.data.description;
      },
      error: (error) => {
      }
    });
  }

  getDistributorById(id: string): void {
    this.distributorService.getDistributorById(id).subscribe({
      next: (response) => {
        this.profileData = {
          id: response.data.id,
          companyName : response.data.companyName,
          name: response.data.firstName + ' ' + response.data.lastName,
          logo: response.data.logo,
          url: response.data.url,
          description: response.data.description,
          address: response.data.address,
          country : response.data.country,
          state: response.data.state,
          city : response.data.city,
          email : response.data.email,
          phoneNumber : response.data.phoneNumber,
          videos: response.data.videos,
          photos : response.data.photos,
          productCategoriesName : response.data?.productCategoriesName ?? [],
          type: 'distributor'
        };
        this.activeTab = 0;
        this.spinnerService.hideSpinner();

      },
      error: (error) => {
      }
    });
  }

  getAllProductsById(brandId: string) {
    this.allProductService.getAllProductsByOemId(brandId).subscribe({
      next: (response) => {
        this.products = response.data;
      },
      error: (error) => {
      }
    });
  }

  getAllDistributorById(brandId: string) {
    this.oemService.getOemDistributorById(brandId).subscribe({
      next: (response) => {
        this.distributorNetwork = response.data;
      },
      error: (error) => {
      }
    });
  }

  getBrandsByDistributorId(brandId : string) {
    this.oemService.getOEMsByDistributorId(brandId).subscribe({
      next: (response) => {
        this.brands = response.data;
      },
      error: (error) => {
      }
    });
  }


  setTabSliderWidth() {
    const tabs = document.querySelectorAll('.tab');
    if (tabs.length > 0) {
      this.tabSliderWidth = (tabs[0] as HTMLElement).offsetWidth;
    }
  }

  setTabSliderPosition() {
    this.tabSliderPosition = this.activeTab * this.tabSliderWidth;
  }

  selectTab(index: number) {
    if (index !== this.activeTab) {
      this.previousTab = this.activeTab;
      this.activeTab = index;
      this.setTabSliderPosition();
      this.selectedTabName = this.getTabName(index);
    }
  }

  handleSelectDistributor(distributor: any): void {
    this.router.navigate([`website-distributor/brand-profile/${distributor.id}`],{
      queryParams: { type: 'distributor' }
    }).then(() => {
      this.getDistributorById(distributor.id);
      this.selectTab(0);
    });
  }

  handleSelectOEM(brand: any): void {
    this.router.navigate([`brands/brand-profile/${brand.id}`],{
      queryParams: { type: 'brand' }
    }).then(() => {
      this.getOEMsBYId(brand.id);
      this.selectTab(0);
    });
  }

  getTabName(index: number): string {
    switch (index) {
      case 0:
        return 'Company Profile';
      case 1:
        this.brandProfileProducts='Products'
        return 'Products';
      case 1:
        this.brandProfileProducts='Product List'
        return 'Product List';
      case 2:
         this.brandProfileProducts='Catalogs'
        return 'Catalogs';
      case 3:
        this.brandProfileProducts='Exhibitions'
        return 'Exhibitions';
      case 4:
        return 'Contact Us';
      default:
        return 'Unknown';
    }
  }
   brandNavigate(): void {
    this.router.navigate(['./brands'], {});
  }
distributorNavigate(): void {
    this.router.navigate(['./website-distributor'], {});
  }

  showContentForPdf = false;
  private async generateProfilePdf(
    elementIds: string[],
    pdfFileName: string,
    isDownload: boolean = true
  ): Promise<void> {
    try {
      this.spinnerService.showSpinner();

      const pdf = new jsPDF('p', 'mm', 'a4');
      const margin =10;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableWidth = pageWidth - 2 * margin;

      pdf.setProperties({
        title: `${this.profileData.companyName} `,
        subject: 'Company Profile Document',
        author: 'MedWorld Expo',
        keywords: 'Profile, PDF, Company, Brand',
        creator: 'MedWorld',
      });

      for (const elementId of elementIds) {
        const element = document.getElementById(elementId);

        if (!element) {
          continue;
        }

        // Standardize the view for PDF
        element.style.display = 'block';
        element.style.width = '1600px'; // Fixed width for consistent rendering
        element.style.maxWidth = 'none';
        element.style.overflow = 'visible';

        // Generate canvas with consistent scaling
        const canvas = await html2canvas(element, {
          scale: 3, // Uniform scale for both views
          useCORS: true,
          allowTaint: true,
          logging: false,
          scrollX: 0,
          scrollY: -window.scrollY,
          windowWidth: 1600, // Fixed width
          windowHeight: element.scrollHeight,
        });

        const imgData = canvas.toDataURL('image/jpeg', 1.0); // High quality
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = usableWidth;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

        // Add image to PDF
        if (imgHeight <= pageHeight - 2 * margin) {
          pdf.addImage(imgData, 'JPEG', margin, margin, imgWidth, imgHeight);
        } else {
          const totalPages = Math.ceil(imgHeight / (pageHeight - 2 * margin));
          let currentPage = 1;

          for (let offset = 0; offset < totalPages; offset++) {
            if (currentPage > 1) pdf.addPage();

            const cropCanvas = document.createElement('canvas');
            cropCanvas.width = canvas.width;
            cropCanvas.height = (pageHeight - 2 * margin) * canvas.height / imgHeight;

            const context = cropCanvas.getContext('2d');
            if (context) {
              context.drawImage(
                canvas,
                0,
                offset * cropCanvas.height,
                cropCanvas.width,
                cropCanvas.height,
                0,
                0,
                cropCanvas.width,
                cropCanvas.height
              );
            }

            const croppedImgData = cropCanvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(
              croppedImgData,
              'JPEG',
              margin,
              margin,
              imgWidth,
              pageHeight - 2 * margin
            );
            pdf.setFontSize(8);
            pdf.text(`Page ${currentPage}`, pageWidth / 2, pageHeight - 5, {
              align: 'center',
            });
            currentPage++;
          }
        }
      }

      if (isDownload) {
        pdf.save(`${pdfFileName}.pdf`);
      }
       else {
        // const pdfBlob = pdf.output('blob');
        // const pdfUrl = URL.createObjectURL(pdfBlob);
        // window.open(pdfUrl, '_blank', );
        const pdfBlob = pdf.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const a = document.createElement('a');
        const ss = this.profileData.companyName.replace(/\s/g, '_');

        a.href = `${pdfUrl}#${ss}`;

        a.target = '_blank';

        a.click();


      }
      this.captureMode = false;
      this.spinnerService.hideSpinner();
    } catch (error) {
      this.captureMode = false;
      this.spinnerService.hideSpinner();
    }
  }

  accessDenied() {
    Swal.fire({
      title: 'Access Denied!',
      text: 'Please Login or SignUp',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }

  viewProfile(): void {
    if(!this.isLogin) {
      this.accessDenied();
      return;
    }
    this.spinnerService.showSpinner();
    this.captureMode = true;
    const fileName = `${this.profileData.companyName}_Profile`;
    setTimeout(async () => {
      const pdfUrl = await this.generateProfilePdf(
        ['companyInfo-page'],
        fileName,
        false
      );

    //   if (typeof pdfUrl === 'string') {
    //   window.open(pdfUrl, '_blank');
    // }
  }, 1000);
    this.spinnerService.hideSpinner();
  }

  downloadProfile(): void {
    if(!this.isLogin) {
      this.accessDenied();
      return;
    }
    this.spinnerService.showSpinner();
    this.captureMode = true;
    setTimeout(() => {
      this.generateProfilePdf(['companyInfo-page'], this.profileData.companyName, true);
    }, 1000);
    this.spinnerService.hideSpinner();
  }
}


